import ContentLayout from "./ContentLayout";

export default ContentLayout;
